import { showModal } from '../../components/Modal';
import { location } from 'cdui-js';
import { postToApp } from '../../../../lib/rnBridge';
import { clearAgreementPdfCache } from '../../../../lib/agreement-pdf-cache';
import { clearH5TokenAfterNewOpen, isH5User } from '../../../../stores/user';
import i18n from '../../../../i18n';
import { clearSzcaCertCache, clearSzcaPendingState } from './on-line/risk/szca-face';

/**
 * 通知 App 结束开户 + 清 CA 本地缓存 + 清协议 PDF 预载。
 * - H5：保留 token，跳 /app-download（用户可后续回看开户进度）
 * - App：通知原生 FINISHOPEN，并清 H5 token / 弹登录页（保持原逻辑）
 */
export const finishOpenAccount = () => {
  clearSzcaPendingState();
  clearSzcaCertCache();
  clearAgreementPdfCache();
  postToApp({ type: 'WEB_TO_APP_FINISHOPEN' });
  if (isH5User()) {
    // H5：保留登录态，跳下载页（/app-download 已在 redirectH5ToOpenProgressIfNeeded 白名单，不会被自动跳走）
    // 带 s=1 标记开户流程已完成，app-download 页据此隐藏"立即开户"按钮
    location.routeTo('/app-download?s=1');
    return;
  }
  // App：保持原逻辑（清 token + 跳 /my + 弹登录页）
  clearH5TokenAfterNewOpen();
};

/** 提交成功：仅 H5 弹窗后退出；App 直接 FINISHOPEN，不弹窗（不进 H5 Reviewing） */
export const showSubmitSuccessModal = () => {
  if (!isH5User()) {
    finishOpenAccount();
    return;
  }

  showModal({
    disableClickMask: true,
    title: i18n.OpenProgress.Entry.SubmitSuccess,
    content: () => '',
    confirmText: i18n.OpenProgress.Common.Next,
    onConfirm: () => {
      finishOpenAccount();
    },
  });
};

/** 从 submitApply 等异常里取出可读文案 */
export const getSubmitErrorMessage = (err: unknown) => {
  if (typeof err === 'string') return err.replace(/^\d+\s+/, '').trim();
  const msg = String((err as { message?: unknown })?.message ?? err ?? '').trim();
  return msg.replace(/^\d+\s+/, '').trim();
};

/**
 * 最后一步提交失败 / 非 200：单按钮「确认」弹窗，点后立刻回 App（或 H5 下载页）。
 * 调用方应对 submitApply 传 X-No-Toast，避免与拦截器 Toast 叠两层。
 * 系统返回 / 取消路径同样回 App，避免关弹窗后停在提交页。
 */
export const showSubmitFailThenFinish = (err?: unknown) => {
  const message = getSubmitErrorMessage(err) || i18n.OpenProgress.Entry.LoadFailed;
  const leave = () => finishOpenAccount();
  showModal({
    disableClickMask: true,
    title: message,
    content: () => '',
    confirmText: i18n.OpenProgress.Common.Confirm,
    onConfirm: leave,
    onCancel: leave,
  });
};
